export const appDesktopMobileToggle = {
    create: function(){
        var that = this;
        if($('.course-teaser-desktop-content').length){
            that.checkCourseTeasers();
        }
        if($('.project-teaser-desktop-content').length){
            that.checkProjectTeasers();
        }
        if($('[data-mblview]').length){
            that.checkMobileElements();
        }
        that.bindEvents();
    },
    bindEvents: function(){
        var that = this;
        $(window).on('resize', function(){
            if($('.course-teaser-desktop-content').length){
                that.checkCourseTeasers();
            }
            if($('.project-teaser-desktop-content').length){
                that.checkProjectTeasers();
            }
            if($('[data-mblview]').length){
                that.checkMobileElements();
            }
        });
    },
    checkCourseTeasers: function(){
        var that = this,
            wWidth = $(window).width();
        $('.course-teaser-desktop-content').each(function(){
            if(wWidth > 768){
                $(this).attr('aria-hidden','false');
            } else {
                $(this).attr('aria-hidden','true');
            }
        });
        $('.course-teaser-mobile-content').each(function(){
            if(wWidth > 768){
                $(this).attr('aria-hidden','true');
            } else {
                $(this).attr('aria-hidden','false');
            }
        });
    },
    checkProjectTeasers: function(){
        var that = this,
            wWidth = $(window).width();
        $('.project-teaser-desktop-content').each(function(){
            if(wWidth > 768){
                $(this).attr('aria-hidden','false');
            } else {
                $(this).attr('aria-hidden','true');
            }
        });
        $('.project-teaser-mobile-content').each(function(){
            if(wWidth > 768){
                $(this).attr('aria-hidden','true');
            } else {
                $(this).attr('aria-hidden','false');
            }
        });
    },
    checkMobileElements: function(){
        var that = this,
            wWidth = $(window).width();
        $('[data-mblview="false"]').each(function(){
            if(wWidth > 768){
                $(this).attr('aria-hidden','false');
            } else {
                $(this).attr('aria-hidden','true');
            }
        });
        $('[data-mblview="true"]').each(function(){
            if(wWidth > 768){
                $(this).attr('aria-hidden','true');
            } else {
                $(this).attr('aria-hidden','false');
            }
        });
    }
};